'use client';

import { UISerializableLiquidationRecord } from '@drift/common';
import { useEffect, useState } from 'react';
import { getAggregateLiqs } from 'src/utils/liquidation';
import {
	AggregateLiqState,
	GroupedLiqState,
} from './useAggregateLiquidationDataForUser';

const useAggregateLiquidations = (
	liquidations: UISerializableLiquidationRecord[]
) => {
	const [groupedLiqLookup, setGroupedLiqLookup] = useState<GroupedLiqState>({});

	const [aggregateLiqState, setAggregateLiqState] = useState<
		AggregateLiqState[]
	>([]);

	useEffect(() => {
		const newLiqState: GroupedLiqState = {};

		if (liquidations.length === 0) {
			setGroupedLiqLookup({});
		}

		liquidations.forEach((liq) => {
			const liqId = `${liq.user.toString()}_${liq.liquidationId}`;
			if (newLiqState[liqId]) {
				newLiqState[liqId].push(liq);
			} else {
				newLiqState[liqId] = [liq];
			}
		});

		if (liquidations.length > 0) {
			setGroupedLiqLookup(newLiqState);
		}
	}, [liquidations]);

	useEffect(() => {
		const newAggregateLiqState = getAggregateLiqs(groupedLiqLookup);
		setAggregateLiqState(newAggregateLiqState);
	}, [groupedLiqLookup]);

	return aggregateLiqState;
};

export default useAggregateLiquidations;
